import * as actionTypes from '../actions/actionTypes';

export default function currentActivationTabReducer(state = [], action) {
  switch(action.type){
    case actionTypes.SET_ACTIVATION_TAB_DATA: {
      return action.activationdata;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/activationTabReducer.js